import { createAction } from 'redux-actions';

const ns = 'changeLanguage/';

export const showChangeLanguage = createAction<boolean>(`${ns}SHOW_CHANGE_COMPANY`);

export const setCurrentLanguage = createAction<string>(`${ns}SET_CURRENT_LANGUAGE`);
